export const handleAsync = (state, action, { req, res, err, dataKey, errorKey = 'errors', loadedKey }) => {
  switch (action.type) {
    case req:
      return { ...state, [loadedKey || `${dataKey}_loaded`]: false };
    case res:
      return { ...state, [loadedKey || `${dataKey}_loaded`]: true, [dataKey]: action.payload };
    case err:
      return {
        ...state,
        [errorKey]: (state[errorKey] && [...state[errorKey], action.error]) || [action.error],
      };
    default:
      return null;
  }
};
